module.exports = __webpack_public_path__ + "img/loading.58d21bc6.gif";